import React from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { AchievementsSection } from '../components/AchievementsSection';
import { ServicesSection } from '../components/ServicesSection';
import { NichesSection } from '../components/NichesSection';
import { ProcessSteps } from '../components/ProcessSteps';
import { AdvantagesSection } from '../components/AdvantagesSection';
import { CeoSection } from '../components/CeoSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ContactForm } from '../components/ContactForm';
import { Footer } from '../components/Footer';
import { useSEO } from '../hooks/useSEO';
import { useLanguage } from '../context/LanguageContext';
const seoData = {
  UA: {
    title: 'ESCA — Executive Search & Recruiting Agency | Підбір керівників та спеціалістів',
    description: 'ESCA — міжнародна агенція з підбору керівників та спеціалістів. 20+ років досвіду, база 20 000+ кандидатів. Executive Search, IT Recruitment, комплектація команд.',
    keywords: 'executive search, підбір персоналу, рекрутинг, HR агенція, підбір керівників, IT рекрутинг, хедхантинг, Україна, ESCA'
  },
  RU: {
    title: 'ESCA — Executive Search & Recruiting Agency | Подбор руководителей и специалистов',
    description: 'ESCA — международное агентство по подбору руководителей и специалистов. 20+ лет опыта, база 20 000+ кандидатов. Executive Search, IT Recruitment, комплектация команд.',
    keywords: 'executive search, подбор персонала, рекрутинг, HR агентство, подбор руководителей, IT рекрутинг, хедхантинг, Украина, ESCA'
  },
  EN: {
    title: 'ESCA — Executive Search & Recruiting Agency | Top Talent Recruitment',
    description: 'ESCA — international executive search and recruiting agency. 20+ years of experience, 20,000+ candidate database. Executive Search, IT Recruitment, Team Building.',
    keywords: 'executive search, recruitment agency, headhunting, HR agency, IT recruitment, talent acquisition, Ukraine, ESCA'
  }
};
export function LandingPage() {
  const {
    lang
  } = useLanguage();
  const seo = seoData[lang];
  useSEO({
    title: seo.title,
    description: seo.description,
    keywords: seo.keywords,
    ogType: 'website'
  });
  return <div className="min-h-screen w-full bg-white overflow-x-hidden" data-id="element-842">
      <Header data-id="element-843" />
      <main data-id="element-844">
        <HeroSection data-id="element-845" />
        <AchievementsSection data-id="element-846" />
        <ServicesSection data-id="element-847" />
        <NichesSection data-id="element-848" />
        <ProcessSteps data-id="element-849" />
        <AdvantagesSection data-id="element-850" />
        <CeoSection data-id="element-851" />
        <TestimonialsSection data-id="element-852" />
        <ContactForm data-id="element-853" />
      </main>
      <Footer data-id="element-854" />
    </div>;
}